import { useAppContext } from "../app/Context"
import type { CustomBranding } from "../types/Agent"
import { brandingStyles } from "../utils/branding"

export const useBranding = (): CustomBranding | null => {
  const agent = useAppContext()?.agent
  return brandingStyles(agent)
}
